import { render } from "./SeriesEditView.vue?vue&type=template&id=50c3a24d&scoped=true"
import script from "./SeriesEditView.vue?vue&type=script&lang=js"
export * from "./SeriesEditView.vue?vue&type=script&lang=js"

import "./SeriesEditView.vue?vue&type=style&index=0&id=50c3a24d&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c3a24d"]])

export default __exports__